<template>
  <div>
    <b-button class="actionIcon mt-1 pointer" @click="showEditCategoryModal = true" title="Edit question bank category" ><i class="fa-solid fa-arrows font-size-20"></i></b-button>
    <!-- modal -->
    <div
      v-if="showEditCategoryModal"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editScoreModalLabel"
      :aria-hidden="!showEditCategoryModal"
    >
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content bg-white" style="z-index: 1051; position: relative;">
            <div class="modal-header">
              <h5 class="modal-title">Rename question bank category</h5>
              <i @click="showEditCategoryModal = false" class="fa-solid fa-xmark font-size-20 pointer"></i>
            </div>

            <div class="modal-body">
              <div class="p-3 rounded rounded-2 bg-light my-3">
                <div style="display: flex;">
                  <i class="fas fa-info-circle text-primary" style="font-size: 20px; margin-right: 12px;"></i>
                  <div>
                    <p class="mb-0 text-primary">
                      This action will update the category of all questions linked to the old question bank category across the app.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Old qbk category -->
              <div class="col-md-12 mb-3">
                <label>Old qbk category</label>
                <input disabled :value="propQuestionBankObj.qbk_category" type="text" class="form-control"/>
              </div><!-- Old qbk category -->
              <!-- New qbk category -->
              <div class="col-md-12 mb-3">
                <label>New qbk category</label>
                <input v-model="vmQuestionBankFormData.qbk_category" placeholder="Enter new qbk category" class="form-control"/>
                <label class="text-danger" v-if="errorMessage">{{ errorMessage }}</label>
              </div><!-- New qbk category -->
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="showEditCategoryModal = false">Close</button>
              <button type="button" @click="quizBankEdit()" class="btn btn-primary">Save</button>
            </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import { QuizBanks } from "../../../FackApi/api/quizBank"
import ApiResponse from "../../../Utils/apiResponse.js"

export default {
  name: "ChangeCategoryModal",
  props: {
    propQuestionBankObj: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showEditCategoryModal: false,
      vmQuestionBankFormData: {},
      errorMessage: null,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Change Question Bank Category"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  methods: {
    async quizBankEdit () {
      if (!this.vmQuestionBankFormData?.qbk_category) {
        this.errorMessage = "Qbk Category is required."
        return
      }
      else {
        this.errorMessage = null
      }

      this.vmQuestionBankFormData.qbk_id = this.propQuestionBankObj.qbk_id
      if (this.propQuestionBankObj.app_id && this.propQuestionBankObj.qbk_category) {
        this.vmQuestionBankFormData.app_id = this.propQuestionBankObj.app_id
        this.vmQuestionBankFormData.oldQbk_category = this.propQuestionBankObj.qbk_category
      }

      try {
        let quizBankAddResp = await QuizBanks.quizBankEdit(this, this.vmQuestionBankFormData)

        ApiResponse.responseMessageDisplay(this, quizBankAddResp)
        if (quizBankAddResp && quizBankAddResp.resp_status) {
          this.showToast = true
          this.toastMsg = "Qbk Category updated successfully."
          this.toastVariant = "success"
          this.$emit("emitQuizBankList")
          this.showEditCategoryModal = false
        }
        else {
          this.showToast = true
          this.toastMsg = "Failed to update Qbk Category. Please try again."
          this.toastVariant = "danger"
        }
        this.$emit("emitCloseChangeCategoryModal")
      }
      catch (err) {
        console.error("Exception occurred at quizBankEdit() and Exception:", err.message)
        this.showToast = true
        this.toastMsg = "An unexpected error occurred while updating Qbk Category. Please try again later."
        this.toastVariant = "danger"
      }
    }
  }
}
</script>

<style scoped>
.alert-box {
  border-left: 4px solid var(--bs-primary);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
